import { render, staticRenderFns } from "./OverlaySwapIcon.vue?vue&type=template&id=001fd952&"
import script from "./OverlaySwapIcon.vue?vue&type=script&lang=js&"
export * from "./OverlaySwapIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports